module.exports = __webpack_public_path__ + "img/mail.31a6080b.svg";